import type { ReportCategoryStat, StatisticsReport } from "../../lib/types";
import type { GroupedExpense } from "./StatisticsPayees";

export function buildAllTransactionsBreakdown(report?: StatisticsReport): ReportCategoryStat[] {
  if (!report) return [];
  const transferTotal = report.accounts.reduce((sum, account) => sum + Number(account.base_transfer_out), 0);
  const entries = [
    { id: "expense", name: "Expenses", icon: "banknote-out", color: "#ef4444", amount: Number(report.totals.expense) },
    { id: "income", name: "Income", icon: "banknote-in", color: "#22c55e", amount: Number(report.totals.income) },
    { id: "transfer", name: "Transfers", icon: "wallet", color: "#3b82f6", amount: transferTotal },
  ];
  const total = entries.reduce((sum, entry) => sum + entry.amount, 0);
  return entries.map((entry) => ({
    category_id: entry.id,
    category_name: entry.name,
    icon: entry.icon,
    color: entry.color,
    amount: String(entry.amount),
    count: 0,
    average_amount: String(entry.amount),
    percent: total ? entry.amount / total * 100 : 0,
    previous_amount: "0",
    amount_delta: String(entry.amount),
  }));
}

export function groupReportExpenses(
  report: StatisticsReport | undefined,
  currency: string,
): GroupedExpense[] {
  const groups = new Map<string, GroupedExpense>();
  for (const expense of report?.top_expenses || []) {
    const merchant = expense.merchant || "No payee";
    const key = `${merchant}|${expense.category_id || ""}`;
    const amount = Number(expense.currency === currency ? expense.amount : expense.base_amount ?? expense.amount);
    const entry = groups.get(key);
    if (entry) {
      entry.total += amount;
      entry.count += 1;
      if (expense.occurred_at > entry.lastDate) entry.lastDate = expense.occurred_at;
    } else {
      groups.set(key, {
        merchant,
        categoryId: expense.category_id,
        categoryName: expense.category_name || "Uncategorized",
        currency,
        total: amount,
        count: 1,
        lastDate: expense.occurred_at,
      });
    }
  }
  return [...groups.values()].sort((a, b) => b.total - a.total).slice(0, 8);
}
